export default {
  appointmentContainer: {
    title: 'Immobilienschäden',
    solution: 'Lösung:',
    text: 'Wählen Sie einen von Allianz zugelassenen Fachmann',
    text2: 'Gewünschtes Datum für die Arbeiten',
    text3: 'Gewünschte Durchgangszeit:',
    infoBox: 'Wenn die Zeitfenster nicht verfügbar oder mit Ihren Verfügbarkeiten nicht kompatibel sind, wählen Sie, innerhalb von 48 Stunden* zurückgerufen zu werden, um den Termin zu vereinbaren.',
    workHour: '*Geschäftszeiten und außer bei außergewöhnlichen oder unkontrollierbaren Problemen',
    actions: {
      primary: 'Uhrzeit bestätigen',
      secondaryHelpText: 'Passt Ihnen keine dieser Zeiten?',
      secondary: 'Zurückgerufen werden, um einen Termin zu vereinbaren',
      ren: {
        primary: 'Zeitfenster bestätigen',
        tertiary: 'Eine andere Lösung wählen'
      }
    },
    dates: {
      months: {
        january: 'Januar',
        february: 'Februar',
        march: 'März',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Dezember'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Ein Fehler ist aufgetreten! Es war nicht möglich, die verfügbaren Tage für die Terminvereinbarung abzurufen.',
        postAppointment: 'Fehler! Der ausgewählte Termin konnte nicht geplant werden.',
        postContact: 'Fehler! Der Kontakt konnte nicht angefordert werden.'
      }
    }
  }
}
